import { Pageable } from './pageable';
import { Sort } from './sort';

export class Page <T> {
    content: Array<T>;
    pageable: Pageable;
    totalElements: number;
    totalPages: number;
    last: boolean;
    size: number;
    number: number;
    sort: Sort;
    first: boolean;
    numberOfElements: number;

    constructor() {
        this.pageable = new Pageable();
        this.totalElements = 0;
        this.totalPages = 0;
        this.last = true;
        this.size = 0;
        this.number = 0;
        this.sort = new Sort();
        this.first = true;
        this.numberOfElements = 0;
    }

}

